
import { Component, Vue, Prop } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import { getReservationClientList, cancelReservationClient, getCancelPolicy } from '@/api/reservationClient';
import moment from 'moment';
import Calendar from '@/components/Calendar/index.vue';
import { getAiStoreInfoList } from '@/api/storeInfo';
import { getIndustryList } from '@/api/industry';
import { getCurrentPosition } from '@/utils/mylocation';
import {
  getLat,
  getLng,
  setLat,
  setLng,
} from '@/utils/cookies';

@Component({
  components: {
    Pagination,
    Calendar,
  },
})

export default class extends Vue {
  @Prop({ required: true }) private status!: Number;

  mounted() {
    this.getReservationList();
    this.getIndustryList();
  }

  private lastRandomIndexes: Record<number, number> = {};

  private randomIdx(idx: number): number {
    if (this.lastRandomIndexes[idx] !== undefined) {
      return this.lastRandomIndexes[idx];
    }
    const randomIndex = Math.floor(Math.random() * this.aiItem.placeList.length);
    this.lastRandomIndexes[idx] = randomIndex;
    return randomIndex;
  }

  private restaurantrandomIdx(idx: number): number {
    if (this.lastRandomIndexes[idx] !== undefined) {
      return this.lastRandomIndexes[idx];
    }
    const randomIndex = Math.floor(Math.random() * this.aiItem.restaurantList.length);
    this.lastRandomIndexes[idx] = randomIndex;
    return randomIndex;
  }

  private apiUrl = process.env.VUE_APP_COMMON_API;

  private loading = true;

  private dateRange = [];

  private filterSortDrawer = false;

  private categorySortDrawer = false;

  private listQuery: any = {
    searchValue: '',
    industryIdx: null,
    page: 1,
    size: 5,
    region: '',
    lat: getLat(),
    lng: getLng(),
    adult: 1,
    child: 0,
    status: this.status,
    tabName: '',

    useStart: this.$route.query.useStart ? this.$route.query.useStart : moment().startOf('year').format('YYYY-MM-DD'),
    useEnd: this.$route.query.useEnd ? this.$route.query.useEnd : moment().endOf('year').format('YYYY-MM-DD'),
    sort: 'useDate',
  }

  private sortList = [
    { label: '최신순', value: 'useDate' },
    { label: '과거순', value: 'pastDate' },
  ]

  private industryList: any = [];

  private randomIndex = 0;

  private getIndustryList() {
    this.loading = true;
    getIndustryList().then((res) => {
      this.loading = false;
      this.industryList = res.data;
      this.industryList.forEach((item: any, index: any) => {
        if (item.name === '일반상품') {
          this.industryList.splice(index, 1);
        }
        if (item.name === '레저') {
          this.industryList.splice(index, 1);
        }
        if (item.name === '체험') {
          item.name = '레저 / 체험';
        }
      });
      this.industryList.splice(1, 0, { idx: 7, name: '캠핑' });
    });
  }

  private zeroPayRefundVisible = false;

  private searchRange = [];

  private totalElements = 0;

  private clientList = [];

  private cancelyn = '';

  private viewDetail(uid: string) {
    // this.$router.push({ name: 'ReservationBreakDownDetail', params: { clientUid: uid } });
    console.log(uid);
  }

  // Calendar
  private selectedDay: string | null = '';

  private datePickerVisible = false;

  @Prop()
  private calendarData = []; // 달력 일별 데이터

  private selectedMonth = moment().format('YYYY-MM');

  private handleChoiceDate(startDate: string, endDate: string) {
    this.selectedDay = startDate;
    this.listQuery.useStart = startDate;
    this.listQuery.useEnd = endDate;
  }

  private handleResetFormQuery() {
    this.totalSearchQuery = {
      searchValue: '',
      industryIdx: null,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      adult: 1,
      child: 0,
      page: 0,
      size: 2,
    };
    const calendarRef: any = this.$refs.calendar;
    if (calendarRef) calendarRef.removeActiveClass();
  }

  private aiItem = {
    stayList: [],
    restaurantList: [],
    placeList: [],
    leisureList: [],
    excitingList: [],
    productList: [],
  }

  private async getAiItemList() {
    try {
      const position = await getCurrentPosition();
      this.totalSearchQuery.lat = position.lat;
      this.totalSearchQuery.lng = position.lng;
    } catch (error) {
      this.$message.error('위치 정보를 가져오는 데 실패했습니다.');
    }
    this.aiSearchLoading = true;
    this.getAiStoreInfoList();
  }

  private getAiStoreInfoList() {
    getAiStoreInfoList({
      page: 0,
      size: 4,
      lat: this.totalSearchQuery.lat,
      lng: this.totalSearchQuery.lng,
      restaurantCnt: 4,
      placeCnt: 4,
    }).then((res) => {
      this.aiItem = {
        ...this.aiItem,
        ...res.data,
      };
      this.aiSearchLoading = false;
    });
  }

  private aiSearchLoading = false;

  private totalSearchQuery: any = {
    searchValue: '',
    industryIdx: null,
    startDate: this.$route.query.startDate ? this.$route.query.startDate : moment().format('YYYY-MM-DD'),
    endDate: this.$route.query.endDate ? this.$route.query.endDate : moment().add(1, 'days').format('YYYY-MM-DD'),
    adult: 1,
    child: 0,
  }

  private handleChangeMonth(yearMonth: any) {
    this.selectedMonth = moment(yearMonth).format('YYYY-MM');
    this.calendarData = [];
  }

  private getReservationList() {
    this.loading = true;
    getReservationClientList(this.listQuery).then((res) => {
      this.clientList = res.data.content;
      this.totalElements = res.data.totalElements;
      this.loading = false;
      this.getAiItemList(); // 여기 어때요
    });
  }

  private handleSearch() {
    this.totalSearchQuery = {
      ...this.totalSearchQuery,
      page: 1,
    };
    this.getReservationList();
  }

  private handleTotalSearch() {
    if (this.status === 0) this.listQuery.tabName = 'beforeUse';
    else if (this.status === 1) this.listQuery.tabName = 'afterUse';
    else if (this.status === -1) this.listQuery.tabName = 'cancel';
    this.$router.push({ name: 'mypageOrder', query: { ...this.listQuery } });
  }
  // Calendar

  private handleChangeDateRange() {
    if (this.dateRange && this.dateRange.length === 2) {
      this.listQuery.useStart = this.dateRange[0];
      this.listQuery.useEnd = this.dateRange[1];
    } else {
      this.listQuery.useStart = '';
      this.listQuery.useEnd = '';
    }
    this.handleSearch();
  }

  private cancelable(client: any) {
    return client.useDate >= moment().format('YYYY-MM-DD');
  }

  private handleCancel(client: any, index: number) {
    this.handleCancelClient(client, index);
  }

  private handleCancelClient(client: any, index: number) {
    getCancelPolicy(client.uid).then((res: any) => {
      const policy = res.data;
      let message = `${client.storeName}(${client.useDate} ~ ${client.endDate}) ${client.industry}정보를 예약 취소하시겠습니까?\n\n`;

      if (policy.percentage > 0) {
        message += `■ 취소 위약금: ${policy.penaltyPrice.toLocaleString()}원 (${policy.percentage}%)\n`;
        message += `■ 환불 예상 금액: ${policy.refundPrice.toLocaleString()}원\n\n`;
      } else {
        message += `■ 환불 예상 금액: ${policy.refundPrice.toLocaleString()}원 (전액 환불)\n\n`;
      }

      message += '※ 취소 시 사용하셨던 쿠폰은 반환되지 않습니다.';

      this.$confirm(message, '예약 취소', {
        cancelButtonText: '아니오',
        confirmButtonText: '예',
        type: 'warning',
      }).then(() => {
        cancelReservationClient(client.uid, {}).then(() => {
          this.$message.success('예약이 취소되었습니다.');
          this.clientList.splice(index, 1);
        });
      });
    }).catch(() => {
      this.$message.error('취소 정책 정보를 불러올 수 없습니다.');
    });
  }

  private handleClickSort(sort: string) {
    this.loading = true;
    this.clientList = [];
    this.filterSortDrawer = false;
    this.categorySortDrawer = false;
    this.listQuery.page = 0;
    this.listQuery.sort = sort;
    this.getReservationList();
  }

  private selectedIndustryName = '카테고리 전체';

  private handleClickIndustry(industry: any) {
    this.selectedIndustryName = industry.name;
    this.loading = true;
    this.filterSortDrawer = false;
    this.categorySortDrawer = false;
    this.listQuery.page = 0;
    this.listQuery.industryIdx = industry.idx;
    this.getReservationList();
  }

  private getSortLabel() {
    let label = '';
    const idx = this.sortList.findIndex((sort: any) => sort.value === this.listQuery.sort);
    if (idx > -1) label = this.sortList[idx].label;
    return label;
  }

  private isSeclect01Visible = false;

  private openSeclect01() {
    // console.log(`'isSeclect01Visible : ${this.isSeclect01Visible}'`);
    this.isSeclect01Visible = !this.isSeclect01Visible;
  }

  private closeModal() {
    this.isSeclect01Visible = false;
    this.handleTotalSearch();
  }

  private getReserveUrl(client: any) {
    if (client.industryIdx === 1) return `/stay/room/${client.itemUid}`;
    if (client.industryIdx === 2 || client.industryIdx === 3) return `/leisure/${client.storeIdx}`;
    if (client.industryIdx === 4) return { name: 'RestaurantView', params: { idx: client.storeIdx } };
    if (client.industryIdx === 5) return { name: 'GoodsView', params: { uid: client.itemUid } };
    if (client.industryIdx === 6) return { name: 'PlaceDetail', params: { idx: client.storeIdx, itemUid: client.itemUid } };
    return {};
  }

  private handleRetry(client: any) {
    const route: any = this.getReserveUrl(client);
    this.$router.push(route);
  }

  private getReserveInfo(client: any) {
    if (client.industryIdx === 1) return `${client.itemName} / 체크인 날짜:${client.useDate} / 체크아웃 날짜: ${client.endDate}`;
    if (client.industryIdx === 2 || client.industryIdx === 3) return `${client.itemName} / 예약날짜: ${client.useDate}`;
    return {};
  }

  private handleKakaoShare(client: any) {
    const route: any = this.getReserveUrl(client);
    const baseUrl = process.env.VUE_APP_TARGET;
    const shareUrl = baseUrl + route;
    (window as any).Kakao.cleanup();
    (window as any).Kakao.init(process.env.VUE_APP_KAKAO_APP_KEY);
    (window as any).Kakao.Link.sendDefault({
      objectType: 'feed',
      content: {
        title: client.storeName,
        description: this.getReserveInfo(client),
        imageUrl: client.storeThumbUid ? `${baseUrl}/api/attached-file/${client.storeThumbUid}` : `${baseUrl}/favicon.ico`,
        link: {
          mobileWebUrl: shareUrl,
          webUrl: shareUrl,
        },
      },
      social: {
        likeCount: 0,
        commentCount: 0,
        sharedCount: 0,
      },
      buttons: [
        {
          title: `${client.industryIdx === 1 ? '객실 보러가기' : '보러가기'}`,
          link: {
            mobileWebUrl: shareUrl,
            webUrl: shareUrl,
          },
        },
      ],
    });
  }

  private handleVisibleZeroPayRefundForm(client: any) {
    this.$router.push({ name: 'ZeropayRefund', params: { uid: client.uid } });
    // this.zeroPayRefundVisible = true;
    // this.curClient = client;
  }
}
